import { useCallback, useRef } from "react";
import { isDev } from "../../base/index.js";
function useWarnOnce() {
  const rWarned = useRef(false);
  return useCallback((...messages) => {
    if (!rWarned.current && isDev()) {
      console.warn(...messages);
      rWarned.current = true;
    }
  }, []);
}
export {
  useWarnOnce
};
//# sourceMappingURL=useWarnOnce.js.map
